'use client';

import { StatusBadge } from '@/components/ui/status-badge';

/**
 * DocumentCertifiedBadge — the "Certified" pill the matter's Documents tab
 * shows against a certified copy.
 *
 * One definition, because the badge now has to say the same thing on more than
 * one screen (VALE-1011): a document badged "Certified" in the Documents tab
 * and badged nothing on the AI review surfaces reads as the two screens
 * disagreeing about the same document, and whether a death certificate or an
 * identity document is certified changes what the outgoing institution letter
 * may say about it. It was previously written out by hand in `document-row`
 * and `document-drawer`, which is how a third copy in the extraction picker
 * would have started drifting.
 *
 * Not to be confused with the two older, divergent treatments still in the
 * tree: `CertifiedCopyBadge` (`@/components/ui/certified-copy-badge`, "Certified
 * Copy" with a Shield, used by `UnifiedDocumentCard`, the notifications
 * workflow, the grant issued step and the communications composer) and this
 * module's own `CertifiedBadge` (production-dead). Consolidating all three onto
 * one treatment is a separate cleanup, not this badge's job.
 */
export function DocumentCertifiedBadge() {
  return (
    <StatusBadge tone="info" emphasis="subtle" className="shrink-0">
      Certified
    </StatusBadge>
  );
}
